import ApiService from './ApiService';
import { getAuth } from 'firebase/auth';

class PromptService {
  constructor() {
    this.apiService = new ApiService(process.env.REACT_APP_REFINE_QUERY_URL);
    this.bigQueryApiService = new ApiService(process.env.REACT_APP_BIG_QUERY_URL);
  }

  async getAuthToken() {
    const auth = getAuth();
    const user = auth.currentUser;
    if (!user) {
      throw new Error('No authenticated user found');
    }
    return user.getIdToken();
  }

  // async generateInversePrompts(userPrompt, userData) {
  //   try {
  //     const authToken = await this.getAuthToken();
  //     const response = await this.bigQueryApiService.post('/generate-inverse-prompts', {
  //       user_prompt: userPrompt,
  //       user_data: userData
  //     });

  //     return response;
  //   } catch (error) {
  //     console.error('Error generating inverse prompts:', error);
  //     throw error;
  //   }
  // }

  // async findInverseMatches(userQuery, maxResults = 10, similarityThreshold = 0.7) {
  //   try {
  //     const authToken = await this.getAuthToken();
  //     const response = await this.bigQueryApiService.post('/find-inverse-matches', {
  //       user_query: userQuery,
  //       max_results: maxResults,
  //       similarity_threshold: similarityThreshold
  //     });

  //     return response;
  //   } catch (error) {
  //     console.error('Error finding inverse matches:', error);
  //     throw error;
  //   }
  // }

  async decryptData(encryptedData, userId) {
    try {
      const authToken = await this.getAuthToken();
      const response = await this.apiService.post('/api/v1/decrypt', {
        encrypted_data: encryptedData,
        user_id: userId
      }, {
        headers: {
          'Authorization': `Bearer ${authToken}`
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error decrypting data:', error);
      throw error;
    }
  }

  async refinePrompt(userInput) {
    try {
      const authToken = await this.getAuthToken();
      const response = await this.apiService.post('/api/v1/refine-prompt', {
        userInput
      }, {
        headers: {
          'Authorization': `Bearer ${authToken}`
        }
      });

      // Decrypt the response if it's encrypted
      if (response.data.encrypted_data) {
        const decryptedData = await this.decryptData(response.data.encrypted_data, response.data.user_id);
        return {
          ...response.data,
          ...decryptedData
        };
      }

      return response.data;
    } catch (error) {
      console.error('Error refining prompt:', error);
      throw error;
    }
  }

  async applyRefinement(originalPrompt, refinementType, userResponse) {
    try {
      const authToken = await this.getAuthToken();
      const response = await this.apiService.post('/api/v1/apply-refinement', {
        originalPrompt,
        refinementType,
        userResponse
      }, {
        headers: {
          'Authorization': `Bearer ${authToken}`
        }
      });

      // Decrypt the response if it's encrypted
      if (response.data.encrypted_data) {
        const decryptedData = await this.decryptData(response.data.encrypted_data, response.data.user_id);
        return {
          ...response.data,
          ...decryptedData
        };
      }

      return response.data;
    } catch (error) {
      console.error('Error applying refinement:', error);
      throw error;
    }
  }

  async refinePromptV2(query, selectedProfiles) {
    try {
      const authToken = await this.getAuthToken();
      const selectedProfilesData = selectedProfiles.map(profile => ({
        id: profile.id || '',
        name: profile.name || '',
        position: profile.position || '',
        company: profile.company || '',
        email: profile.email || '',
        url: profile.url || profile.linkedin || ''
      }));

      const response = await this.apiService.post('/api/v2/refine-prompt', {
        originalPrompt: query,
        selectedProfiles: selectedProfilesData
      }, {
        headers: {
          'Authorization': `Bearer ${authToken}`
        }
      });

      // Decrypt the response if it's encrypted
      if (response.data.encrypted_data) {
        const decryptedData = await this.decryptData(response.data.encrypted_data, response.data.user_id);
        return {
          ...response.data,
          ...decryptedData
        };
      }

      return response.data;
    } catch (error) {
      console.error('Error refining prompt v2:', error);
      throw error;
    }
  }
}

export default new PromptService(); 